
<template>
  <div class="center">
    <div class="text-center">
      <h1>404</h1>
      <p>มีข้อผิดพลาดเกิดขึ้น ไม่พบหน้านี้</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  created() {},
  data() {
    return {};
  },
  props: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  height:calc(100vh - 64px - 40px) ;
}
</style>

